// Module 0 (clôture) — « Sur qui j'agis ? » : population de l'utilisateur pour une permission.
// Sert à ne proposer que les sites autorisés (le serveur refuse de toute façon les autres) et à
// afficher clairement le périmètre de travail.
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function usePerimetre(permission) {
  const [perimetre, setPerimetre] = useState(null);
  const [sitesReferentiel, setSitesReferentiel] = useState([]);
  useEffect(() => {
    let actif = true;
    const token = localStorage.getItem('sogas_token');
    const headers = { Authorization: `Bearer ${token}` };
    axios.get(`${API}/api/perimetre/moi`, { params: { permission }, headers })
      .then(async ({ data }) => {
        if (!actif) return;
        setPerimetre(data);
        if (data.global) {
          const r = await axios.get(`${API}/api/referentiel/sites`, { headers }).catch(() => ({ data: {} }));
          if (actif) setSitesReferentiel(r.data?.sites || []);
        }
      })
      .catch(() => { if (actif) setPerimetre({ global: false, sites: [], libelle: 'Périmètre indisponible', nb_personnes: 0 }); });
    return () => { actif = false; };
  }, [permission]);
  const sites = perimetre ? (perimetre.global ? sitesReferentiel.filter((s) => s.actif !== false) : perimetre.sites) : [];
  return { perimetre, sites, charge: perimetre !== null };
}
